import React from 'react';
import { Field } from '@cordata/buffet';

const PERMISSION_OPTIONS = ['create', 'read', 'update', 'delete'].map(p => ({ value: p, label: p }));

const PermissionsField = () => (
  <Field
    name="aiAvailableResourcePermissions"
    type="checkbox-group"
    options={PERMISSION_OPTIONS}
    getOptionValue={o => o.value}
    getOptionLabel={o => o.label}
  />
);

export default PermissionsField;
